import Snap from 'snapsvg-cjs'
import Helper from './Helper';

class Animation {
	constructor(config = {}) {
		const {
			svgSelector,
			final,
			gerade,
			umgekehrt
		} = config;
		this.svg = svgSelector;

		if(this.svg !== null){
			this.s = Snap(this.svg);
			this.final = Snap.select(final);
			this.gerade = Snap.select(gerade);
			this.umgekehrt = Snap.select(umgekehrt);

			this.finalCupPoints = this.final.node.getAttribute('d');
			this.geradePoints = this.gerade.node.getAttribute('d');
			this.thirdPoints = this.umgekehrt.node.getAttribute('d');

			this.anim1 = this.anim1.bind(this);
			this.anim2 = this.anim2.bind(this);
			this.anim3 = this.anim3.bind(this);
			this.anim4 = this.anim4.bind(this);
			this.anim5 = this.anim5.bind(this);
			this.anim1();
		}
	};


  anim1(){
    this.gerade.animate({ d: this.finalCupPoints }, 1000, mina.linear, this.anim2);
  }

  anim2(){
    this.gerade.animate({ d: this.geradePoints }, 1000, mina.backout, () => {
      setTimeout(() => { this.anim3() }, 100);
    });
  }

  anim3(){
    this.gerade.animate({ d: this.thirdPoints }, 1000, mina.linear, this.anim4);
  }

  anim4(){
    this.gerade.animate({ d: this.geradePoints }, 1000, mina.backout, () => {
      setTimeout(() => { this.anim5() }, 100);
    });
  }

  anim5(){
    this.gerade.animate({ d: this.finalCupPoints }, 1000, mina.linear);
  }
}
export default Animation;
